import { createTheme } from "@mui/material/styles"
import type { Theme } from "@mui/material/styles"
import type { OverviewColorMode } from "./OverviewColorModeMenu"

export const createOverviewTheme = (parent: Theme, mode: OverviewColorMode) => {
    const colors = mode === "plum" ? {
        primary: {
            main: "#6253B8",
            dark: "#292B44",
            light: "#BCAFFF",
            contrastText: "#FFFFFF",
        },
        secondary: {
            main: "#7765B8",
            dark: "#55488B",
            light: "#BCAFFF",
            contrastText: "#FFFFFF",
        },
        background: {
            default: "#FFFFFF",
            paper: "#FFFFFF",
        },
        text: {
            primary: "#292B42",
            secondary: "#707388",
        },
        divider: "#E7E7EF",
        success: { main: "#257652" },
        warning: { main: "#96630C" },
        error: { main: "#AE3244" },
        info: { main: "#166976" },
    } : mode === "ocean" ? {
        primary: { main: "#147B82", dark: "#0E6269", light: "#3A9AA0", contrastText: "#FFFFFF" },
        secondary: { main: "#397CAB", dark: "#285F89", light: "#67A0C5", contrastText: "#FFFFFF" },
        background: { default: "#F3F8F8", paper: "#FFFFFF" },
        text: { primary: "#19383C", secondary: "#4A676A" },
        divider: "#C9DFDE",
        success: { main: "#237653" },
        warning: { main: "#92600C" },
        error: { main: "#B13C4A" },
        info: { main: "#286D9B" },
    } : {
        primary: { main: parent.palette.primary.main, dark: "#344652", light: "#607483", contrastText: "#FFFFFF" },
        secondary: { main: parent.palette.secondary.main, dark: "#258A80", light: "#70CABE", contrastText: "#172E2B" },
        background: { default: "#F4F7F7", paper: "#FFFFFF" },
        text: { primary: "#253941", secondary: "#526775" },
        divider: "#DBE4E5",
        success: { main: "#237653" },
        warning: { main: "#92600C" },
        error: { main: "#B13C4A" },
        info: { main: "#258A80" },
    }
    return createTheme(parent, {
        palette: {
            mode: "light",
            action: createTheme({ palette: { mode: "light" } }).palette.action,
            ...colors,
        },
    })
}
